import {Injectable} from '@angular/core';
import {BaseService} from './base-service';
import {OrganizationRewardProgramCard} from '../_models/organization-reward-program-card';

@Injectable({
    providedIn: 'root'
})
export class OrganizationRewardCardService extends BaseService<OrganizationRewardProgramCard> {
    destination = 'organization-reward-cards';
}
